"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function isNonNumeric() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isValid = !/\d/gi.test(value);
  var message = isValid ? '' : 'Caracteres não númericos não são aceitos nesse campo';
  return new classes_1.ValidationResult(isValid, message);
}
exports.default = new classes_1.Validator(isNonNumeric);